import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import category from 'Assets/img/svg/categories/categoriesImage.svg';
import categoryMobile from 'Assets/img/svg/categories/categoriesMobile.svg';
export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
			minWidth: 300,
			width: '95%',
			margin: '0 auto',
		},
		menuHeaderBackground: {
			width: '100%',
			fontSize: '16px',
		},
		categoriesImage: {
			[theme.breakpoints.down('xs')]: {
				width: '100% !important', // Overrides inline-style
				objectFit: 'cover',
				height: 'fit-content',
			},
		},
		loading: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: '3rem',
		},
		textOverlay: {
			background: '#FBCC3E',
			padding: '1rem',
			fontSize: '12px',
			[theme.breakpoints.down('xs')]: {
				fontSize: '12px !important',
			},
		},
		fontSize: {
			fontSize: '14px',
			[theme.breakpoints.down('xs')]: {
				fontSize: '14px !important',
			},
		},
		menuHeaderImage: {
			margin: '-10rem auto 2rem',
			display: 'flex',
			justifyContent: 'center',
		},
		listItems: {
			listStyleType: 'none',
		},
		type: {
			fontSize: '24px',
			color: 'rgba(53, 56, 63, 1)',
			padding: '0 1rem',
		},
		greetingInformation: { width: '80%', margin: '0 auto' },
		links: {
			color: 'rgba(120, 57, 61, 1)',
			textDecoration: 'none',
			width: '100%',
			'&:hover': {
				color: 'rgb(80 35 38)',
			},
		},
		description: {
			position: 'relative',
			padding: 0,
			fontSize: '18px',
			color: 'rgba(120, 57, 61, 1)',
			margin: '0',
		},
		elements: {
			position: 'relative',
		},
		image: {
			position: 'relative',
			height: 'auto',
			borderRadius: '1rem',
			[theme.breakpoints.down('xs')]: {
				width: '100% !important', // Overrides inline-style
				height: 100,
			},
			'&:hover, &$focusVisible': {
				zIndex: 1,
				'& $imageBackdrop': {
					opacity: 0.15,
				},
				'& $imageMarked': {
					opacity: 0,
				},
				'& $imageTitle': {
					// border: '4px solid currentColor',
				},
			},
		},
		focusVisible: {},
		imageButton: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			color: theme.palette.common.white,
			borderRadius: '2rem',
		},
		imageSrc: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			backgroundSize: 'cover',
			backgroundPosition: 'center 40%',
			borderRadius: '1rem',
		},
		imageBackdrop: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			backgroundColor: theme.palette.common.black,
			opacity: 0.4,
			transition: theme.transitions.create('opacity'),
			borderRadius: '1rem',
		},

		imageMarked: {
			height: 3,
			width: 18,
			backgroundColor: theme.palette.common.white,
			position: 'absolute',
			bottom: -2,
			left: 'calc(50% - 9px)',
			transition: theme.transitions.create('opacity'),
		},
	}),
);
